import axios from '@/plugins/axios';

export const getBackorders = async (
  userId,
  channel,
  roles,
  office,
  axiosConfig = { noCancelRequest: true }
) => {
  const response = await axios.post(
    '/get-backorders-history',
    { userId, channel, roles, office },
    axiosConfig
  );
  return response.data;
};

export const deleteBackorder = async (
  reminders,
  { firstReason, secondReason }
) => {
  const deleteReminderData = {
    reminders: reminders,
    comments: firstReason,
    comments_0: secondReason,
  };

  const response = await axios.post('/deleteReminder', deleteReminderData);
  return response.data;
};
